import React from 'react';
import { academicYearGraceEnd, formatYmd, isAcademicYearLocked } from '../../utils/classAcademicYear';
import { useSelectedAcademicYear } from '../../utils/selectedAcademicYear';

/** 일일기록·할일노트·예산노트: 메뉴에서 고른 학년도가 지난 학년도면 읽기 전용·내려받기 안내 */
const AcademicYearLockNotice: React.FC<{ label: string }> = ({ label }) => {
  const year = useSelectedAcademicYear();
  if (!isAcademicYearLocked(year)) return null;
  return (
    <div className="cp-year-lock-notice" role="note">
      {year}학년도 {label}은(는) 기록이 중지되어 읽기만 할 수 있습니다. {formatYmd(academicYearGraceEnd(year))}까지
      [설정 › 클래스 › 학년도 일반 자료 내려받기]로 저장해 두세요. 그 뒤에는 서버에서 삭제됩니다.
    </div>
  );
};

export default AcademicYearLockNotice;
